/**
 * Company Configuration
 * Global constants for the platform
 * Location: Florida, USA
 */

export const COMPANY_CONFIG = {
  // Location
  country: 'United States',
  countryCode: 'US',
  state: 'Florida',
  stateCode: 'FL',
  timezone: 'America/New_York',
  
  // Currency - All monetary values default to USD
  currency: 'USD',
  currencySymbol: '$',
  currencyLocale: 'en-US',
  
  // Locale settings
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'fr'] as const,
  
  // Business defaults
  businessHoursStart: 9, // 9 AM
  businessHoursEnd: 18, // 6 PM
  workDays: [1, 2, 3, 4, 5] as const, // Monday to Friday
} as const;

/**
 * Format currency using company defaults
 */
export function formatCurrency(
  amount: number,
  currency: string = COMPANY_CONFIG.currency,
  options?: Intl.NumberFormatOptions
): string {
  return new Intl.NumberFormat(COMPANY_CONFIG.currencyLocale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(amount);
}

/**
 * Format number with company locale
 */
export function formatNumber(
  value: number,
  options?: Intl.NumberFormatOptions
): string {
  return new Intl.NumberFormat(COMPANY_CONFIG.currencyLocale, options).format(value);
}

/**
 * Get default currency for new records
 */
export function getDefaultCurrency(): string {
  return COMPANY_CONFIG.currency;
}

export type SupportedLanguage = typeof COMPANY_CONFIG.supportedLanguages[number];
